export default "__VITE_ASSET__Dtgst9JU__"